module.exports = "/assets/e949d1f2d6e8b13bf7008de7f7870e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KU.png
// module id = 1558
// module chunks = 0